import script from "./MProfileResume.vue?vue&type=script&setup=true&lang=js"
export * from "./MProfileResume.vue?vue&type=script&setup=true&lang=js"

import "./MProfileResume.vue?vue&type=style&index=0&id=47aeda3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47aeda3a"]])

export default __exports__